/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const PeopleAltNull = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M5.19212 3.86865C4.46132 4.51013 4 5.45119 4 6.5C4 8.433 5.567 10 7.5 10C7.89367 10 8.27217 9.93501 8.62533 9.81516L7.84855 8.46973C7.73536 8.48963 7.61889 8.5 7.5 8.5C6.39543 8.5 5.5 7.60457 5.5 6.5C5.5 6.01008 5.67616 5.5613 5.96859 5.21355L5.19212 3.86865Z"
                        fill={color}
                    />
                    <path
                        d="M9.88803 12.0022C9.32636 12.8645 9 13.8942 9 15V19.6619C9 20.4568 9.47035 21.1755 10.223 21.4312C11.5385 21.8781 13.7403 22.4905 15.9489 22.4999L15.0604 20.961C13.3906 20.827 11.772 20.3732 10.7055 20.0109C10.6162 19.9806 10.5 19.8745 10.5 19.6619V15C10.5 14.4844 10.5976 13.9915 10.7752 13.5389L9.88803 12.0022Z"
                        fill={color}
                    />
                    <path
                        d="M13.4338 11.1437L12.6657 9.8133C13.2394 9.61041 13.8568 9.5 14.5 9.5H17.5C20.5376 9.5 23 11.9624 23 15V19.6619C23 20.4568 22.5297 21.1755 21.777 21.4312C21.2246 21.6189 20.5159 21.8357 19.716 22.0248L18.9303 20.6638C19.8421 20.4708 20.6646 20.2249 21.2945 20.0109C21.3838 19.9806 21.5 19.8745 21.5 19.6619V15C21.5 12.7909 19.7091 11 17.5 11H14.5C14.1308 11 13.7732 11.05 13.4338 11.1437Z"
                        fill={color}
                    />
                    <path
                        d="M10.9784 6.89083L8.90026 3.29134C10.1363 3.83149 11 5.06488 11 6.5C11 6.63211 10.9927 6.76252 10.9784 6.89083Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 5C20 7.20914 18.2091 9 16 9C13.7909 9 12 7.20914 12 5C12 2.79086 13.7909 1 16 1C18.2091 1 20 2.79086 20 5ZM18.5 5C18.5 6.38071 17.3807 7.5 16 7.5C14.6193 7.5 13.5 6.38071 13.5 5C13.5 3.61929 14.6193 2.5 16 2.5C17.3807 2.5 18.5 3.61929 18.5 5Z"
                        fill={color}
                    />
                    <path
                        d="M7.5 10.5C8.01123 10.5 8.50617 10.5698 8.97582 10.7003C8.65178 11.116 8.37364 11.5692 8.14901 12.0524C7.93778 12.0179 7.72098 12 7.5 12H6.5C4.29086 12 2.5 13.7909 2.5 16V18.8905C2.5 19.1061 2.61776 19.2044 2.69692 19.2301C3.78632 19.5834 5.42109 20 7 20C7.17134 20 7.34333 19.9951 7.51521 19.9859C7.56415 20.5064 7.73031 21.0111 8.00079 21.4552C7.66997 21.4839 7.33499 21.5 7 21.5C5.19277 21.5 3.38553 21.0304 2.23414 20.6569C1.47475 20.4106 1 19.6888 1 18.8905V16C1 12.9624 3.46243 10.5 6.5 10.5H7.5Z"
                        fill={color}
                    />
                    <path
                        d="M5.90002 0L19.15 22.9497L17.851 23.6997L4.60099 0.75L5.90002 0Z"
                        fill={color}
                    />
                </svg>
        );
    };
